module.exports = __webpack_public_path__ + "img/tema-1-7.26e0da10.svg";